module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-7.d47caffb.jpg";